const Button = ({ onClick, children, className, size = 'large' }) => {
    switch (size) {
        case 'small':
            className = `${className} px-6 py-1 lg:px-8 lg:py-2`;
            break;
        case 'large':
        default:
            className = `${className} px-8 py-2 lg:px-16 lg:py-4`;
            break;
    }

    return (
        <button
            onClick={onClick}
            className={`text-black nobblee-regular text-xl lg:text-3xl bg-app-yellow rounded-[4rem] border-2 border-app-black ${className}`}
        >
            {children}
        </button>
    );
};

export default Button;
